import React from "react";

const Wrapper = (props) => {

    const background = props.background;

    const styles = {
        background: background, 
    };

    return(
        <div style={{background: background}} className={`game-container__wrapper`}>{props.children}</div>
    );
}

export default Wrapper;